export enum ETelaSistema {
    PainelNegocio = 'Painel de Negócio',
    VisualisarLog = 'Visualizar Log',
    UsuarioOnline = 'Usuário Online',
    AtivoBolsa = 'Ativos Bolsa',
    PermissoesAcesso = 'Permissões de Acesso',
    Usuarios = 'Usuários',
    AtualizarCpf = 'Atualizar CPF',
    ImportarArquivo = 'Importar Arquivo',
    Cliente = 'Cliente',
    Relatorio = 'Relatório',
    SolicitacoesDocumento = 'Solicitações de Documento',
    // CadastroAcionista = 'Cadastro Cliente',
    PerfilUsuario = 'Perfil',
    PainelOperacional = 'Painel Operacional',
    AcompanhamentoCarteira = 'Acompanhamento Carteira',
    AcompanhamentoNegociosFechados = 'Acompanhamento de Negocios Fechados',
    AcompanhamentoProcesso = 'Acompanhamento de Processo',
    ProcessosJuridicos = 'Processos Jurídicos',
    Redistribuicao = 'Redistribuição',
    /** CodigoTela 47 — submenu Dashboard (descricao no banco: Controle de acessos) */
    ControleAcesso = 'Controle de acessos',
    Operacional = 'Operacional',
    PerguntasNovas = 'Perguntas novas',
    PerguntasAndamento = 'Perguntas Andamento',
    PerguntasFinalizadas = 'Perguntas Finalizadas',
    ConfiguracoesChat = 'Configurações do chat',
    PresencaEscritorio = 'Presença no escritório',
    Compras = 'Compras',
}
